import { apiClient } from "../config";

async function getAllTags() {
  const url = "/admin/tags/organization";
  const res = await apiClient.get(url);
  return res.data;
}

export default getAllTags;
